module.exports = __webpack_public_path__ + "static/media/Rec-3-05.95008099.webp";